import { render } from "./bmsProjectOverview.vue?vue&type=template&id=cdf3694c&scoped=true"
import script from "./bmsProjectOverview.vue?vue&type=script&lang=js"
export * from "./bmsProjectOverview.vue?vue&type=script&lang=js"

import "./bmsProjectOverview.vue?vue&type=style&index=0&id=cdf3694c&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf3694c"]])

export default __exports__